import { createApp } from 'vue';
import './style.css';
import App from './App.vue';
// store 必须放最前面
import { setupStore } from './store';
import 'element-plus/dist/index.css';
import './styles/index.less';
import { setupElementPlus } from '@/plugins/elementPlus';

const app = createApp(App);
import { setupRouter } from './router';
import { setupPermissionDirective } from './directives/permission';

setupStore(app);

const setupAll = () => {
  setupElementPlus(app);
  setupPermissionDirective(app);
  setupRouter(app);
  app.mount('#app');
};

setupAll();
